import { Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'card-graphic-small-legacy-component',
    // templateUrl: './card-graphic-small-legacy.component.html'
    templateUrl: './card-graphic-small-legacy.v2.component.html',
    styleUrl: './card-graphic-small-legacy.v2.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardGraphicSmallLegacyComponent {
  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  @Input() total?: string;
  @Input() label?: string;
  @Input() data?: string;
  @Input() icon?: string;
  @Input() graphicType?: string;
  @Input() contactInfoChart?: number;
  @Input() radius?: number;
  @Input() textColor?: string;
  @Input() totalContact?: number;
  @Input() datasetTitle?: string;

  @Input() selectable?: boolean = false;
  @Input() selected?: boolean = false;


  showXAxis = true;
  showYAxis = false;
  gradient = true;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = '';
  showYAxisLabel = false;
  yAxisLabel = '';
  timeline = true;
  doughnut = true;
  colorScheme = {
    domain: ['#9370DB', '#87CEFA', '#FA8072', '#FF7F50', '#90EE90']
  };
  showLabels = true;

  public single = [
    {
      "name": "Seg",
      "value": 2243772
    },
    {
      "name": "Ter",
      "value": 1126000
    },
    {
      "name": "Qua",
      "value": 296215
    },
    {
      "name": "Qui",
      "value": 257363
    },
    {
      "name": "Sex",
      "value": 196750
    },

  ];

  constructor() { }

  ngOnInit() {
  }

  onSelect(string) {
  }

  toggleSelection(): void {
    if (this.selectable) {
      this.selected = !this.selected;
    }
  }
}
